import styles from "./Avatar.module.css"

/**
 * Initials in a circle, standing in for a profile photo that no surface here
 * has: Entra returns no picture claim for this tenant and Graph's User.Read
 * carries none either, and ICIS holds no likeness for clients. Decorative in
 * every placement — the name it belongs to is always rendered beside it, so
 * announcing the initials too would only repeat it.
 */
export function Avatar({ name }: { name: string }) {
  return (
    <span className={styles.avatar} aria-hidden="true">
      {initialsOf(name)}
    </span>
  )
}

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("")
}
